import React from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function ChatComposer({ input, setInput, onSend, sending, language }) {
  return (
              <div className="border-t border-slate-100 p-3 md:p-4 bg-white">
                <div className="flex items-end gap-2">
                  <Textarea
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); }
                    }}
                    placeholder={language === "hindi" ? "अपना सवाल यहाँ लिखें…" : "Type your legal question…"}
                    data-testid="chat-input"
                    rows={1}
                    className="min-h-[44px] max-h-[140px] resize-none rounded-xl"
                  />
                  <Button
                    onClick={() => onSend()}
                    disabled={sending || !input.trim()}
                    data-testid="send-btn"
                    className="rounded-xl bg-[#1E3A8A] hover:bg-[#1E40AF] text-white h-11 w-11 p-0 shrink-0"
                  >
                    <Send size={16} />
                  </Button>
                </div>
                <p className="mt-2 text-[11px] text-slate-400">
                  Advoset provides general information, not legal advice. Always consult a qualified lawyer for your case.
                </p>
              </div>
  );
}
